(ns ycweb.components.toaster
  (:require
   [rum.core :as rum]
   [ycweb.util.core :as u]
   [ycweb.util.sound :as sound]
   [ycweb.components.common :as cmn]))

(declare open-toast)
(def behaviour
  {:processing
   {:background true
    :icon :processing
    :icon-class :is-light
    :spin true
    :timeout 15000
    :timeout-fn #(open-toast % :error "Possible comms error, try again." {})}

   :success
   {:background false
    :icon :success
    :icon-class :is-light
    :spin false
    :timeout 1000}

   :warning
   {:background false
    :icon :warning :icon-class :is-light :spin false :timeout 1000}

   :error
   {:background false :icon :error :icon-class :is-light :spin false :timeout 5000}})

(defn toast-cursor
  "Get the correct namespaced modal atom inside a global app-atom"
  [app-atom]
  (rum/cursor app-atom :toaster))

(rum/defc progress-toaster-overlay < rum/reactive [app-atom]
  (let [{:keys [message open type]} (rum/react (toast-cursor app-atom))
        {:keys [background]} (get behaviour type)]
    [:div
     {:class (u/bem :toaster-overlay [(when (and background open) :is-open)])}]))

;; :subtle-open is used in header.
(defn close-toast [app-atom]
  (swap! (toast-cursor app-atom) assoc :open false :opening false :subtle-open false))

(rum/defc progress-toaster < rum/reactive [app-atom]
  (let [{:keys [message open type show-close-button]} (rum/react (toast-cursor app-atom))
        {:keys [icon icon-class spin]} (get behaviour type)]
    [:aside
     {:class (u/bem :toaster [type (when open :is-open)])}
     [:div.toaster__content
      [:div.toaster__icon-wrapper
       [:i
        {:class
         (u/bem :icon [icon-class icon :block]
           (when spin :u-animate-spin) [])}]]
      [:div.toaster__text
       [:span {:class (u/bem (when spin :loading-text) [])} message]]
      (when show-close-button
        [:div.toaster__close
         [:a.icon-link.icon-block-link.icon-block-link--size-default {:href "#"}
          [:i.icon.icon--block.icon--is-light.icon--close
           {:on-click #(close-toast app-atom)}
           [:span.u-hidden-from-view "Close message"]]]])]]))

(defn open-toast [app-atom type message {:keys [closetime close-fn show-close-button]}]
  (let [toast-atom (toast-cursor app-atom)
        toast-id (u/rand-uuid)
        {:keys [timeout timeout-fn]} (get behaviour type)
        closetime (or closetime timeout)
        close-fn (or close-fn timeout-fn)
        timeout-fn
        #(let [{:keys [open] :as toast} @toast-atom]
           (when (and open (= (:toast-id toast) toast-id))
             (close-toast app-atom)
             (when close-fn (close-fn app-atom))))]
    (when (and (:blitz? @app-atom) (= :error type)) (sound/play :error))
    (reset! toast-atom
      {:toast-id toast-id
       :open true
       :type type
       :message message
       :show-close-button show-close-button})

    (when closetime
      #?(:cljs
         (.setTimeout js/window timeout-fn closetime)
         :clj
         (doto
           (Thread.
             (fn []
               (Thread/sleep closetime)
               (timeout-fn)))

           (.setDaemon true)
           (.start))))))

(defn open-subtle-progress [app-atom]
  (swap! (toast-cursor app-atom) assoc :subtle-open true))

(defn close-subtle-progress [app-atom]
  (swap! (toast-cursor app-atom) assoc :subtle-open false))

(defn update-overlay-message [app-atom overlay-key {:keys [text sub-text] :as msg}]
  (let [overlay-atom (toast-cursor app-atom)]
    (swap! overlay-atom update-in [:overlay overlay-key :message]
      (fn [message]
        (u/maybe assoc
          message
          :text text
          :sub-text sub-text)))))

(rum/defcs loading-overlay <
  rum/reactive
  (rum/local false ::mounted)
  {:did-mount (fn [state] (reset! (::mounted state) true) state)}
  [state app-atom overlay-key & [{:keys [fullscreen?]}]]
  (let [mounted? @(::mounted state)
        overlay-atom (rum/cursor-in (toast-cursor app-atom) [:overlay overlay-key])
        {:keys [text sub-text loading-text?] :or {loading-text? true}}
        (cmn/curact overlay-atom :message)
        overlay (rum/react overlay-atom)]
    (rum/fragment
      [:div.js-loading-overlay
       {:class
        (u/bem :loading-overlay
          [(when (and mounted? (:open? overlay)) :is-open)
           (when fullscreen? :fullscreen)])}
       [:div.loading-overlay__content
        [:div.loading-overlay__icon-wrapper.u-block-center.u-max-width-48
         [:i.u-animate-spin
          {:class (u/bem :icon [:loading :is-dark :large :block])}]]
        [:div.loading-overlay__text.u-margin-top-16
         [:b
          (when loading-text?
            {:class (u/bem :loading-text [:is-absolute])})
          (or text "Loading")]
         (when sub-text
           [:p
            {:class (u/bem :yc-paragraph [:small-force :flush])}
            sub-text])]]])))


(defn open-overlay [app-atom overlay-key & message]
  (let [overlay-atom (toast-cursor app-atom)]
    (swap! overlay-atom update-in [:overlay overlay-key]
      (fn [overlay]
        (->
          overlay
          (assoc :open? true)
          (assoc :message (or (first message) "")))))))

(defn close-overlay [app-atom overlay-key]
  (let [overlay-atom (rum/cursor-in (toast-cursor app-atom) [:overlay overlay-key])]
    (swap! overlay-atom assoc :open? false)))

(defn close-all-overlays
  "Close every open loading overlay. Used by the generic :service/error handler
   so a failed ajax doesn't leave a grey overlay stuck on screen."
  [app-atom]
  (swap! (toast-cursor app-atom) update :overlay
    (fn [overlays]
      (reduce-kv
        (fn [m k v] (assoc m k (assoc v :open? false)))
        {}
        (or overlays {})))))

(defn is-open? [app-atom overlay-key]
  (let [overlay-atom (rum/cursor-in (toast-cursor app-atom) [:overlay overlay-key])]
    (:open? @overlay-atom)))